// extracted by mini-css-extract-plugin
export var parcelRow = "_ul-0";